/**
 * システム管理者詳細ページ専用i18n定数
 */

export const SYSTEM_ADMIN_DETAILS_I18N = {
  // ステータス
  status: {
    active: $localize`:@@systemAdmin.adminDetails.status.active:有効`,
    inactive: $localize`:@@systemAdmin.adminDetails.status.inactive:無効`,
  },

  // バリデーションメッセージ
  validation: {
    checkFields: $localize`:@@systemAdmin.adminDetails.validation.checkFields:各フィールドの内容を再度確認してください`,
    selectRole: $localize`:@@systemAdmin.adminDetails.validation.selectRole:権限を指定してください`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@systemAdmin.adminDetails.message.updateSuccess:管理者の情報を更新しました。`,
    updateError: $localize`:@@systemAdmin.adminDetails.message.updateError:管理者の情報の更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
    inviteSuccess: $localize`:@@systemAdmin.adminDetails.message.inviteSuccess:管理者の招待のメールを送信しました。`,
    inviteError: $localize`:@@systemAdmin.adminDetails.message.inviteError:管理者の招待に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
  },

  // ボタン
  button: {
    close: $localize`:@@systemAdmin.adminDetails.button.close:閉じる`,
  },
} as const;

export type SystemAdminDetailsI18n = typeof SYSTEM_ADMIN_DETAILS_I18N;
